import styles from "./Countdown.module.css";

const CircularProgress = ({ value, maxValue, label, size = 80 }) => {
	// Calculate percentage for the circular progress, handle NaN and negative values
	const safeValue = isNaN(value) ? 0 : Math.max(0, value);
	const percentage = Math.min(safeValue / maxValue, 1);
	const circumference = 2 * Math.PI * 38; // radius = 38
	const strokeDashoffset = circumference * (1 - percentage);

	return (
		<div className={styles.circularProgressWrapper}>
			{/* Circle container */}
			<div className={styles.circleContainer} style={{ width: size, height: size }}>
				{/* Track circle (light gray) */}
				<svg width={size} height={size} viewBox="0 0 100 100">
					<circle cx="50" cy="50" r="38" fill="none" stroke="#e0e0e0" strokeWidth="4" />
					{/* Progress circle (blue) */}
					<circle
						cx="50"
						cy="50"
						r="38"
						fill="none"
						stroke="#4f7bf2"
						strokeWidth="4"
						strokeLinecap="round"
						strokeDasharray={circumference}
						strokeDashoffset={strokeDashoffset}
						transform="rotate(-90 50 50)"
					/>
				</svg>

				{/* Value in the center */}
				<div className={styles.circleValue}>
					<span className={styles.circleValueText}>{isNaN(value) ? 0 : value}</span>
				</div>
			</div>

			{/* Label below the circle */}
			<span className={styles.circleLabel}>{label}</span>
		</div>
	);
};

export default CircularProgress;
